import { define } from 'wicked-elements'

define('[data-component="page-filter"]', {
  onChange() {
    window.GPLA_APP.go(this.element.value)
  },
})
